import React from "react";
import { Box, SxProps, Typography } from "@mui/material";
import CreditIcon from "../../../../../constants/icons/CreditIcon";
import { COLOR_MAP } from "../../../../../constants/ColorNames";

interface IProps {
  sx?: SxProps;
}

const CreditMsg: React.FC<IProps> = ({ sx = {} }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", ...sx }}>
      <CreditIcon />
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "12px",
          lineHeight: "16px",
          color: `${COLOR_MAP.GREY_5}`,
          ml: 1,
        }}
      >
        Each WhatsApp message to a candidate consumes <b>4 Outreach credits</b>
      </Typography>
    </Box>
  );
};

export default CreditMsg;
